// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C12 1 12 1 12 1C5.92496 1.00006 1.00006 5.92484 1 11.9999C1 11.9999 1 11.9999 1 11.9999C1 18.075 5.92487 23 12 23ZM1 11.9999L9.68913 9.68913L12 1L14.3106 9.68913L23 12L14.3106 14.3106L12 23L9.68913 14.3106L1 11.9999Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-compass-1-filled')
export default class Compass1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'compass-1-filled',
    }
  }
}
